var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M10.142 2c.507 0 .975.268 1.232.707l7.714 13.143A1.426 1.426 0 0 1 17.856 18H2.427c-.51 0-.985-.275-1.239-.718a1.43 1.43 0 0 1 .007-1.432L8.91 2.707c.258-.44.725-.707 1.233-.707m0 4.571a.855.855 0 0 0-.858.858v4c0 .475.383.857.857.857a.855.855 0 0 0 .858-.857v-4a.855.855 0 0 0-.857-.858m1.142 8a1.143 1.143 0 1 0-2.285 0 1.143 1.143 0 0 0 2.285 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export default ForwardRef;